export default "__VITE_PUBLIC_ASSET__d1e3f419__"